import { render, staticRenderFns } from "./UCContractServiceItemNameEditor.yaml?vue&type=template&id=c7b4349a&component"
import script from "./UCContractServiceItemNameEditor.yaml?vue&type=script&lang=ts&component"
export * from "./UCContractServiceItemNameEditor.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports